import { axios } from '@/utils/request'
import { resolve } from 'core-js/fn/promise'
import { reject } from 'lodash'
import { method } from 'lodash'

const api = {
  // 淘宝双十一赛马
  getTobaoSaiMa: '61ef5402d1802',
  // 双十一赛马支付宝提现
  getDrawMoney: '61e51b748f63a',
  // 双十一赛马提现短信验证
  getShortMsg: '61ef97dd52e1d',
  getTaobaoList: '/5caac0eed7765',
  douYinDaRenList: '/66ce72b5d9cfa', // 抖音达人
  getDuoduoList: '/5cab274cd7f7c',
  getJingdongList: '/5cab08e9bec82',
  getCsjList: '/6607d1bb15b89', // 穿山甲
  getJingyongList: '/5f5750530b033',
  getDouyinList: '/61cece692be9f',
  getWeipinhuiList: '/60585038260ce',
  addJingdong: '/5cab064de7e2d',
  addCsj: '/6607c65e76dc2', // 穿山甲
  addJingyong: '/5f574efb31c21',
  // 抖Y
  addDouyin: '/61ea679585ae6',
  updateDouyin: '62fef09f54bb5',
  // getDouyinCookieList:'61ea7004cc1f1',
  getDouyinCookieList: '62fef09f54bb5',
  deleteTaobao: '/5cad5149b74fc',
  deleteDouYinDaRen: '/66ce730a697f1', // 抖音达人 - 删除
  updateDouYinDaRen: '/66ce72f18e9ea', // 抖音达人 - 更新
  addDouYinDaRen: '/66cdb5c3361c6', // 抖音达人 - 新增账号
  dydrAuthorisation: '/66cee6276a37d', // 抖音达人 - 扫码打开抖音授权
  dydrJy: '/66d184f7b810b', // 抖音达人 - 校验
  deleteJingdong: '/5cad59fdc426d',
  deleteCsj: '6607d3a744606', // 删除穿山甲
  deleteJingyong: '/5f575fd1c3d3a',
  deleteDouyin: '/6302f5f7526c5',
  deleteDuoduo: '/5cad5477b1e55',
  deleteWeipinhui: '/605854b2f1a54',
  setUpdateAuthTaobao: '/5ce7c5f36337a',
  setUpdateAuthJingdong: '/5ce7c5413b723',
  // 抖Y
  setUpdataAuthDouyin: '/61f0ea43e8b55',
  setUpdateAuthPinduoduo: '/5ce7c5ae388f6',
  createPddPid: '/5d19aa2449dd6',
  getTaobaoById: '/5d1eed3d95f83',
  setTaobaoInfo: '/5d1ec28577699',
  setWeipinhuiRemark: '/6058546823218',
  getTaobaoPidList: '/5d8c8e6f91221',
  setSysTb: '/60a867f89e0eb',
  setSysVph: '/60acacf97257f',
  setSysPdd: '/60a86deee2f24',
  setSysJd: '/60a86c2c9431b',
  setSysCsj: '/6607c65e76dc2',
  setSysDy: '/',
  /**小程序相关接口 */
  getMinProgramList: '/60d68a6b53752',
  addMinProgram: '/60d6884c54c74',
  deleteMinProgram: '/60d68c2fb749e',
  pushMinApp: '/6373004e79b8e',
  // 芒果电影票相关接口
  getMgMovieList: '/633551a562361',
  addMgMovie: '/6335364e7deb1',
  deleteMgMovie: '/6336566a1e4a1',
  // 联盟管理-欢喜物流用户列表
  gethxwlList: '/638cbbc751e36',
  // 联盟管理-欢喜物流-同步订单状态
  setSysHxwl: '/639004b402482',
  // 联盟管理-欢喜物流-开通
  openZfb: '/638b1cd171414',
  // 获取账号的公众号id
  getGzh: '/63a016625b7c7',
  // 精选联盟（可提现余额）提现到支付宝
  cashWithdrawal: '/6413ca6eb60b8',
  // 芒果电影票 - 可提现佣金
  commissionWithdrawal: '/64255c9d7f46f',

  // 获取淘宝联盟自定义推广位列表
  getTbTgwList: '/642e80047c071',
  // 获取京东联盟自定义推广位列表
  getJdTgwList: '/642e87b10d116',
  // 获取拼多多联盟自定义推广位列表
  getPddTgwList: '/642e8d0c27312',
  // 获取抖音联盟自定义推广位列表
  getDyTgwList: '/642e9058eae24',

  // 增加淘宝推广位
  saveTbTgw: '/642e74762eb22',
  // 增加抖音推广位
  saveDyTgw: '/642e9020bdc19',
  // 增加京东推广位
  saveJdTgw: '/642e87507a916',
  // 增加拼多多推广位
  savePddTgw: '/642e8cef5e7ea',

  // 删除淘宝推广位
  delTbTgw: '/642f6b25dd6ac',
  // 删除抖音推广位
  delDyTgw: '/642f6d03ec109',
  // 删除京东推广位
  delJdTgw: '/642f6ca8cdf2c',
  // 删除拼多多推广位
  delPddTgw: '/642f6ce7e74bb',

  // 编辑淘宝推广位
  editTbTgw: '/642e94b50e24b',
  // 编辑抖音推广位
  editDyTgw: '/642e97ed8054f',
  // 编辑京东推广位
  editJdTgw: '/642e97a78f6c1',
  // 编辑拼多多推广位
  editPddTgw: '/642e97d2e6c56',

  // 京喜团授权列表
  getJxtList: '/6448961cd9665',
  // 京喜团同步订单
  setSysJxtuan: '.6442562ca810c',
  // 京喜团备注
  jxtRemark: './6448c6b2627a7',
  // 删除京喜团列表
  jxtDelete: './6448c9c747a0d',
  // 违规订单
  getIrregularOrders: '/646d760abecf0',

  // 抖音订单导入任务相关接口
  getTiktokOrderTaskList: '6989a2ec68781',
  getTiktokTaskImportOrderList: '6989a9a9a5445',
  tiktokGongxiangOrderExcelImport: '6986f650d012d',
  getTiktokGongxiangOrderImportDataCount: '6989a47808732',
  confirmTiktokGongxiangOrderSettle: '6989a3999d518',
}

export default {
  getShortMsg: data => {
    return axios({
      url: api.getShortMsg,
      method: 'post',
      data,
    }).then(res => {
      return res
    })
  },

  dydrJy: data => {
    return axios({
      url: api.dydrJy,
      method: 'post',
      data,
    }).then(res => {
      return res
    })
  },

  getDrawMoney: data => {
    return axios({
      url: api.getDrawMoney,
      method: 'post',
      data,
    }).then(res => {
      return res
    })
  },
  getTobaoSaiMa: data => {
    // const params = Object.assign()
    return axios({
      url: api.getTobaoSaiMa,
      method: 'post',
      data,
    }).then(res => {
      return res
    })
  },
  // 获取欢喜物流列表
  gethxwlList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.gethxwlList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },
  // 获取淘宝联盟列表
  getTaobaoList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getTaobaoList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },

  // 获取抖音达人列表
  douYinDaRenList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.douYinDaRenList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },

  // 获取唯品会列表
  getWeipinhuiList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getWeipinhuiList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },
  // 获取多多进宝列表
  getDuoduoList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getDuoduoList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },
  // 获取京东列表
  getJingdongList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getJingdongList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },

  // 获取穿山甲列表
  getCsjList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getCsjList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },

  // 获取京佣列表
  getJingyongList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getJingyongList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },
  // 获取抖Y列表
  getDouyinList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getDouyinList,
      method: 'get',
      params: params,
    }).then(res => {
      return res
    })
  },
  // 获取抖Ycookie list
  getDouyinCookieList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getDouyinCookieList,
      method: 'get',
      params: params,
    }).then(res => {
      res.data.list.forEach(item => {
        Object.assign(item, { expire_time: '2999-12-31 23:59:59' })
      })
      // 官方渠道对象
      const official = {
        authority_id: '官方共享',
        cookie: '0001',
        status: '正常',
        expires_in: '2999-12-31 23:59:59',
        is_sync: 2,
        remark: '无',
        create_time: '2022-8-20 09:50:50',
        access_token: '*******',
      }
      res.data.list.unshift(official)
      return {
        data: res.data.list,
        pageNo: params.pageNo,
        pageSize: params.pageSize,
        totalCount: 1,
      }
    })
  },
  updateDouyin: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.updateDouyin,
      method: 'get',
      params: params,
    }).then(res => {
      res.data.list.forEach(item => {
        Object.assign(item, { expire_time: '2999-12-31 23:59:59' })
      })
      // 官方渠道对象
      const official = {
        authority_id: '官方共享',
        cookie: '0001',
        status: '正常',
        expires_in: '2999-12-31 23:59:59',
        is_sync: 2,
        remark: '无',
        access_token: '*******',
      }
      res.data.list.unshift(official)
      return {
        data: res.data.list,
        pageNo: params.pageNo,
        pageSize: params.pageSize,
        totalCount: 1,
      }
    })
  },

  /** 设置jd同步 */
  setSysJd(data) {
    return axios({
      url: api.setSysJd,
      method: 'post',
      data,
    })
  },

  // 设置穿山甲同步
  setSysCsj(data) {
    return axios({
      url: api.setSysCsj,
      method: 'post',
      data,
    })
  },

  /** 设置vph同步 */
  setSysVph(data) {
    return axios({
      url: api.setSysVph,
      method: 'post',
      data,
    })
  },
  /** 设置pdd同步 */
  setSysPdd(data) {
    return axios({
      url: api.setSysPdd,
      method: 'post',
      data,
    })
  },
  /** 设置淘宝同步 */
  setSysTb(data) {
    return axios({
      url: api.setSysTb,
      method: 'post',
      data,
    })
  },
  // 设置欢喜物流同步
  setSysHxwl(data) {
    return axios({
      url: api.setSysHxwl,
      method: 'post',
      data,
    })
  },
  /** 设置抖Y同步 */
  setSysDy(data) {
    return axios({
      url: api.setSysDy,
      method: 'post',
      data,
    })
  },
  /**
   * 展示小程序列表
   * @param {string} keywords   关键词
   * @param {Enum} search_condition   搜索条件 1 小程序昵称 2 app_id
   * @param {string} sortField
   * @param {string} sortOrder
   * @param {Integer} page
   * @param {Integer} size
   */
  getMinProgramList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getMinProgramList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },
  //获取电影票授权列表
  getMgMovieList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getMgMovieList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },
  // 新增电影票授权
  addMgMovie: ({ nickname }) => {
    const parameter = { nickname }
    return axios({
      url: api.addMgMovie,
      method: 'post',
      data: parameter,
    })
  },
  //删除电影票授权列表
  deleteMgMovie: ({ fans_id }) => {
    const parameter = { fans_id }
    return axios({
      url: api.deleteMgMovie,
      method: 'post',
      data: parameter,
    })
  },
  /**
   * 添加小程序
   * @param {string} app_id   小程序ID
   * @param {string} origin_id   原始ID
   * @param {string} program_name   小程序名称
   */
  addMinProgram: ({ app_id, origin_id, program_name }) => {
    const parameter = { app_id, origin_id, program_name }
    return axios({
      url: api.addMinProgram,
      method: 'post',
      data: parameter,
    })
  },
  /**
   * 删除小程序
   * @param {Integer} id  小程序id号(侯叔返回的)
   */
  deleteMinProgram: ({ id }) => {
    const parameter = { id }
    return axios({
      url: api.deleteMinProgram,
      method: 'post',
      data: parameter,
    })
  },

  // 推广小程序
  pushMinApp: ({ sub_id, min_program_id }) => {
    const parameter = { sub_id, min_program_id }
    return axios({
      url: api.pushMinApp,
      method: 'post',
      data: parameter,
    })
  },

  // 新增京东联盟
  addJingdong: ({ union_id, auth_key, app_key, secret_key, remark }) => {
    const parameter = { union_id, auth_key, app_key, secret_key, remark }
    return axios({
      url: api.addJingdong,
      method: 'post',
      data: parameter,
    })
  },

  // 新增穿山甲
  addCsj: ({ auth_id, secure_key, remark, is_sync }) => {
    const parameter = { auth_id, secure_key, remark, is_sync }
    return axios({
      url: api.addCsj,
      method: 'post',
      data: parameter,
    })
  },

  // 新增京佣联盟
  addJingyong: ({ code, subject_name, remark }) => {
    const parameter = { code, subject_name, remark }
    return axios({
      url: api.addJingyong,
      method: 'post',
      data: parameter,
    })
  },
  // 新增抖Y联盟
  addDouyin: data => {
    return axios({
      url: api.addDouyin,
      method: 'post',
      data,
    }).then(res => {
      return res
    })
  },
  // 删除淘宝联盟
  deleteTaobao: ({ union_id }) => {
    const parameter = {
      taobao_user_id: union_id,
    }
    return axios({
      url: api.deleteTaobao,
      method: 'get',
      params: parameter,
    })
  },
  // 删除多多进宝
  deleteDuoduo: ({ owner_name }) => {
    const parameter = {
      owner_name: owner_name,
    }
    return axios({
      url: api.deleteDuoduo,
      method: 'get',
      params: parameter,
    })
  },
  // 删除京东联盟
  deleteJingdong: ({ union_id }) => {
    const parameter = {
      union_id: union_id,
    }
    return axios({
      url: api.deleteJingdong,
      method: 'get',
      params: parameter,
    })
  },
  // 删除京佣联盟
  deleteJingyong: ({ id }) => {
    const parameter = {
      id: id,
    }
    return axios({
      url: api.deleteJingyong,
      method: 'post',
      data: parameter,
    })
  },
  // 删除唯品会授权
  deleteWeipinhui: ({ open_id }) => {
    const parameter = {
      open_id: open_id,
    }
    return axios({
      url: api.deleteWeipinhui,
      method: 'get',
      params: parameter,
    })
  },
  // 批量更新淘宝授权
  setUpdateAuthTaobao: ({ sub_id, auth_id, tag }) => {
    const parameter = { sub_id, auth_id, tag }
    return axios({
      url: api.setUpdateAuthTaobao,
      method: 'post',
      data: parameter,
    })
  },
  // 批量更新京东授权
  setUpdateAuthJingdong: ({ sub_id, auth_id }) => {
    const parameter = { sub_id, auth_id }
    return axios({
      url: api.setUpdateAuthJingdong,
      method: 'post',
      data: parameter,
    })
  },
  // 批量更新抖Y授权
  setUpdataAuthDouyin: ({ sub_id, auth_id }) => {
    const parameter = { sub_id, auth_id }
    return axios({
      url: api.setUpdataAuthDouyin,
      method: 'post',
      data: parameter,
    })
  },
  // 唯品会授权列表更新备注
  setWeipinhuiRemark: params => {
    const parameter = {
      id: params.id,
      remark: params.remark,
    }
    return axios({
      url: api.setWeipinhuiRemark,
      method: 'post',
      data: parameter,
    })
  },
  // 批量更新拼多多授权
  setUpdateAuthPinduoduo: ({ sub_id, auth_id }) => {
    const parameter = { sub_id, auth_id }
    return axios({
      url: api.setUpdateAuthPinduoduo,
      method: 'post',
      data: parameter,
    })
  },
  // 创建拼多多PID
  createPddPid: ({ union }) => {
    const parameter = { owner_name: union }
    return axios({
      url: api.createPddPid,
      method: 'post',
      data: parameter,
    })
  },
  // 根据ID获取淘宝联盟数据
  getTaobaoById: id => {
    const parameter = {
      id: id,
    }
    return axios({
      url: api.getTaobaoById,
      method: 'get',
      params: parameter,
    })
  },
  // 编辑淘宝授权信息
  setTaobaoInfo: params => {
    const parameter = {
      id: params.id,
      remark: params.remark,
    }
    return axios({
      url: api.setTaobaoInfo,
      method: 'post',
      data: parameter,
    })
  },
  // 获取淘宝联盟推广位列表
  getTaobaoPidList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getTaobaoPidList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },
  // 新增京佣联盟
  addJingyong: ({ code, subject_name, remark }) => {
    const parameter = {
      code,
      subject_name,
      remark,
    }
    return axios({
      url: api.addJingyong,
      method: 'post',
      data: parameter,
    })
  },
  // 删除淘宝联盟
  deleteTaobao: ({ union_id }) => {
    const parameter = {
      taobao_user_id: union_id,
    }
    return axios({
      url: api.deleteTaobao,
      method: 'get',
      params: parameter,
    })
  },

  // 删除抖音达人
  deleteDouYinDaRen: ({ id }) => {
    const parameter = {
      id: id,
    }
    return axios({
      url: api.deleteDouYinDaRen,
      method: 'post',
      data: parameter,
    })
  },

  // 更新抖音达人
  updateDouYinDaRen: (id, remark, is_sync) => {
    const parameter = {
      id,
      remark,
      is_sync,
    }
    return axios({
      url: api.updateDouYinDaRen,
      method: 'post',
      data: parameter,
    })
  },

  // 新增抖音达人
  addDouYinDaRen: () => {
    return axios({
      url: api.addDouYinDaRen,
      method: 'post',
    })
  },

  // 抖音达人 - 打开抖音授权
  dydrAuthorisation: () => {
    return axios({
      url: api.dydrAuthorisation,
      method: 'post',
    })
  },

  // 删除多多进宝
  deleteDuoduo: ({ owner_name }) => {
    const parameter = {
      owner_name: owner_name,
    }
    return axios({
      url: api.deleteDuoduo,
      method: 'get',
      params: parameter,
    })
  },
  // 删除京东联盟
  deleteJingdong: ({ union_id }) => {
    const parameter = {
      union_id: union_id,
    }
    return axios({
      url: api.deleteJingdong,
      method: 'get',
      params: parameter,
    })
  },

  // 删除穿山甲
  deleteCsj: ({ auth_id }) => {
    const parameter = {
      auth_id: auth_id,
    }
    return axios({
      url: api.deleteCsj,
      method: 'get',
      params: parameter,
    })
  },

  // 删除京佣联盟
  deleteJingyong: ({ id }) => {
    const parameter = {
      id: id,
    }
    return axios({
      url: api.deleteJingyong,
      method: 'post',
      data: parameter,
    })
  },
  // 删除抖Y联盟
  deleteDouyin: ({ authority_id }) => {
    const parameter = {
      authority_id: authority_id,
    }
    return axios({
      url: api.deleteDouyin,
      method: 'get',
      params: parameter,
    })
  },
  // 删除唯品会授权
  deleteWeipinhui: ({ open_id }) => {
    const parameter = {
      open_id: open_id,
    }
    return axios({
      url: api.deleteWeipinhui,
      method: 'get',
      params: parameter,
    })
  },
  // 批量更新淘宝授权
  setUpdateAuthTaobao: ({ sub_id, auth_id, tag }) => {
    const parameter = {
      sub_id,
      auth_id,
      tag,
    }
    return axios({
      url: api.setUpdateAuthTaobao,
      method: 'post',
      data: parameter,
    })
  },
  // 批量更新京东授权
  setUpdateAuthJingdong: ({ sub_id, auth_id }) => {
    const parameter = {
      sub_id,
      auth_id,
    }
    return axios({
      url: api.setUpdateAuthJingdong,
      method: 'post',
      data: parameter,
    })
  },
  // 唯品会授权列表更新备注
  setWeipinhuiRemark: params => {
    const parameter = {
      id: params.id,
      remark: params.remark,
    }
    return axios({
      url: api.setWeipinhuiRemark,
      method: 'post',
      data: parameter,
    })
  },
  // 批量更新拼多多授权
  setUpdateAuthPinduoduo: ({ sub_id, auth_id }) => {
    const parameter = {
      sub_id,
      auth_id,
    }
    return axios({
      url: api.setUpdateAuthPinduoduo,
      method: 'post',
      data: parameter,
    })
  },
  // 创建拼多多PID
  createPddPid: ({ union }) => {
    const parameter = {
      owner_name: union,
    }
    return axios({
      url: api.createPddPid,
      method: 'post',
      data: parameter,
    })
  },
  // 根据ID获取淘宝联盟数据
  getTaobaoById: id => {
    const parameter = {
      id: id,
    }
    return axios({
      url: api.getTaobaoById,
      method: 'get',
      params: parameter,
    })
  },
  // 编辑淘宝授权信息
  setTaobaoInfo: params => {
    const parameter = {
      id: params.id,
      remark: params.remark,
    }
    return axios({
      url: api.setTaobaoInfo,
      method: 'post',
      data: parameter,
    })
  },
  // 获取淘宝联盟推广位列表
  getTaobaoPidList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getTaobaoPidList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },

  // 欢喜物流-开通支付宝
  openZfb: ({ user_id, main_id, appid, rmb_price, buy_num }) => {
    return new Promise((resolve, reject) => {
      const link = `https://cloudmanage.nianchu.net/api${api.openZfb}?user_id=${user_id}&main_id=${main_id}&appid=${appid}&rmb_price=${rmb_price}&buy_num=${buy_num}`
      // const link = `http://cloud_test.nianchu.net/api${api.openZfb}?user_id=${user_id}&main_id=${main_id}&appid=${appid}&rmb_price=${rmb_price}&buy_num=${buy_num}`
      resolve(link)
    })
  },

  // 欢喜物流-获取公众号id
  getGzh: parameter => {
    return axios({
      url: api.getGzh,
      method: 'get',
      params: parameter,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo || 1,
        pageSize: parameter.pageSize || 10,
        totalCount: res.data.count,
      }
    })
  },

  // 精选联盟 - 可提现余额
  cashWithdrawal: params => {
    const parameter = {
      user_name: params.user_name,
      user_phone: params.user_phone,
    }
    return axios({
      url: api.cashWithdrawal,
      method: 'post',
      data: parameter,
    })
  },

  // 芒果电影票 - 可提现佣金
  commissionWithdrawal: params => {
    return axios({
      url: api.commissionWithdrawal,
      method: 'post',
      data: params,
    })
  },

  // 获取淘宝联盟自定义推广位列表
  getTbTgwList(parameter) {
    return axios({
      url: api.getTbTgwList,
      method: 'get',
      params: parameter,
    })
  },

  // 获取京东联盟自定义推广位列表
  getJdTgwList(parameter) {
    return axios({
      url: api.getJdTgwList,
      method: 'get',
      params: parameter,
    })
  },

  // 获取拼多多联盟自定义推广位列表
  getPddTgwList(parameter) {
    return axios({
      url: api.getPddTgwList,
      method: 'get',
      params: parameter,
    })
  },

  // 获取抖音联盟自定义推广位列表
  getDyTgwList(parameter) {
    return axios({
      url: api.getDyTgwList,
      method: 'get',
      params: parameter,
    })
  },

  // 增加淘宝推广位
  saveTbTgw: params => {
    return axios({
      url: api.saveTbTgw,
      method: 'post',
      data: params,
    })
  },

  // 增加抖音推广位
  saveDyTgw: params => {
    return axios({
      url: api.saveDyTgw,
      method: 'post',
      data: params,
    })
  },

  // 增加拼多多推广位
  savePddTgw: params => {
    return axios({
      url: api.savePddTgw,
      method: 'post',
      data: params,
    })
  },

  // 增加抖音推广位
  saveJdTgw: params => {
    return axios({
      url: api.saveJdTgw,
      method: 'post',
      data: params,
    })
  },

  // 删除淘宝推广位
  delTbTgw: params => {
    return axios({
      url: api.delTbTgw,
      method: 'post',
      data: params,
    })
  },

  // 删除抖音推广位
  delDyTgw: params => {
    return axios({
      url: api.delDyTgw,
      method: 'post',
      data: params,
    })
  },

  // 删除京东推广位
  delJdTgw: params => {
    return axios({
      url: api.delJdTgw,
      method: 'post',
      data: params,
    })
  },

  // 删除拼多多推广位
  delPddTgw: params => {
    return axios({
      url: api.delPddTgw,
      method: 'post',
      data: params,
    })
  },

  // 编辑淘宝推广位
  editTbTgw: params => {
    return axios({
      url: api.editTbTgw,
      method: 'post',
      data: params,
    })
  },

  // 编辑抖音推广位
  editDyTgw: params => {
    return axios({
      url: api.editDyTgw,
      method: 'post',
      data: params,
    })
  },

  // 编辑京东推广位
  editJdTgw: params => {
    return axios({
      url: api.editJdTgw,
      method: 'post',
      data: params,
    })
  },

  // 编辑拼多多推广位
  editPddTgw: params => {
    return axios({
      url: api.editPddTgw,
      method: 'post',
      data: params,
    })
  },

  // 京喜团授权列表
  getJxtList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getJxtList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },

  // 京喜团同步订单开关
  setSysJxtuan: params => {
    return axios({
      url: api.setSysJxtuan,
      method: 'post',
      data: params,
    })
  },

  // 京喜团备注
  jxtRemark: params => {
    return axios({
      url: api.jxtRemark,
      method: 'post',
      data: params,
    })
  },

  // 删除京喜团列表
  jxtDelete: params => {
    return axios({
      url: api.jxtDelete,
      method: 'get',
      params: params,
    })
  },

  // 违规订单列表
  getIrregularOrders: params => {
    return axios({
      url: api.getIrregularOrders,
      method: 'post',
      data: params,
    })
  },

  // ============ 抖音订单导入任务相关接口 ============

  // 获取抖音订单任务列表
  getTiktokOrderTaskList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getTiktokOrderTaskList,
      method: 'post',
      data: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: params.page,
        pageSize: params.size,
        totalCount: res.data.count,
      }
    })
  },

  // 获取抖音任务订单数据列表
  getTiktokTaskImportOrderList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getTiktokTaskImportOrderList,
      method: 'post',
      data: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: params.page,
        pageSize: params.size,
        totalCount: res.data.count,
      }
    })
  },

  // 抖音共享订单Excel导入（前端解析后传递JSON数据）
  tiktokGongxiangOrderExcelImport: (params) => {
    return axios({
      url: api.tiktokGongxiangOrderExcelImport,
      method: 'post',
      data: params,
    })
  },

  // 获取任务订单统计
  getTiktokGongxiangOrderImportDataCount: (task_id) => {
    return axios({
      url: api.getTiktokGongxiangOrderImportDataCount,
      method: 'post',
      data: { task_id },
    })
  },

  // 抖音共享联盟订单确认结算
  confirmTiktokGongxiangOrderSettle: (params) => {
    return axios({
      url: api.confirmTiktokGongxiangOrderSettle,
      method: 'post',
      data: params,
    })
  },
}
